(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CustomerGroupListController', CustomerGroupListController);

    CustomerGroupListController.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService', 'CustomerGroupCustom', 'pagingParams', 'paginationConstants', '$mdDialog', 'Principal', 'DialogService'];

    function CustomerGroupListController($scope, $state, ParseLinks, AlertService, CustomerGroupCustom, pagingParams, paginationConstants, $mdDialog, Principal, DialogService) {


        var vm = this;


        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.newCustomerGroupClick = newCustomerGroupClick;


        vm.newCustomerGroup = newCustomerGroup;
        vm.editCustomerGroup = editCustomerGroup;
        vm.clearSearch = clearSearch;

        loadAll_paging();

        function loadAll_paging() {

            if (pagingParams.search) {
                CustomerGroupCustom.getAllCompanyCustomerGroups().query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CustomerGroupCustom.getAllCompanyCustomerGroups().query({
                    query: "",
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {

                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customerGroups = data;
                setDefaultGroup();
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function setDefaultGroup() {
            var hasDefault = false;
            angular.forEach(vm.customerGroups, function (group) {
                if (group.groupName == 'DEFAULT_GROUP')
                    hasDefault = true;
            })

            if (!hasDefault) {
                var defaultGroup = {};
                defaultGroup.groupName = 'DEFAULT_GROUP';
                defaultGroup.accessToAllServices = true;
                vm.customerGroups.push(defaultGroup);

            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }


        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }


        function search() {
            if (vm.searchQuery) {
                loadAll_paging();
                vm.links = null;
                vm.page = 1;
                vm.predicate = '_score';
                vm.reverse = false;
                vm.currentSearch = vm.searchQuery;
                vm.transition();
            }
        }

        function newCustomerGroupClick() {
            var result;

            result = Principal.hasSpecialFeatureAccess("customerGroup");
            if (!result) {
                DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
                return;
            }

            $state.transitionTo('supplierPanel.newCustomerGroup');

        }


        function newCustomerGroup() {
            var result;

            result = Principal.hasSpecialFeatureAccess("customerGroup");
            if (!result) {
                DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
                return;
            }

            $state.transitionTo('supplierPanel-v2.newCustomerGroup');

        }

        function editCustomerGroup(cc) {
            $state.go('supplierPanel-v2.editCustomerGroup', {id: cc.id});
        }

        function clearSearch() {
            vm.searchQuery = null;
            pagingParams.search = null;
            loadAll_paging();
        }

        function editCustomerGroup(customerGroup) {

            if (customerGroup.groupName == 'DEFAULT_GROUP' && !customerGroup.id)
                $state.go('supplierPanel-v2.newCustomerGroup_default');
            else
                $state.transitionTo('supplierPanel-v2.editCustomerGroup', {id: customerGroup.id});
        }

    }

})();
